// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"565":"4aaddac01a53ce0a","789":"3ecb9f0a49d4e82b"}[chunkId] + ".js";
};